var _polygon, _polygon2, _path, _path2, _path3, _path4, _path5, _path6, _polygon3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "background-simple",
    "data-motion": "blob",
    "data-delay": 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M611,135.62C623.85,202.57,593.63,274,541.5,317.88s-123.25,61.81-191.21,56.44c-48.51-3.84-97.39-19.66-133.49-52.3s-57.27-83.78-46.58-131.25c4.05-17.93,13.09-35.63,28.6-45.49,24.78-15.74,57.11-7.4,85.1,1.45S344.2,164,369,148.35c19.08-12,27.83-34.78,41.22-52.92C433,64.58,472.07,46.5,510.33,49.07a110.66,110.66,0,0,1,18.89,3c39,9.61,69.48,40.15,80.42,78.82Z",
    style: {
      fill: "#F0F5FA"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "floor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M686.72,448.45c0,.15-139.57.26-311.71.26s-311.73-.11-311.73-.26,139.54-.26,311.73-.26S686.72,448.31,686.72,448.45Z",
    style: {
      fill: "#17324A"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "plant",
    "data-motion": "sway",
    "data-delay": 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.25,410.29c-1.77,2.53-5.21,1.69-6.81.15s-2.27-3.78-2.88-5.92c-1.41-4.87-2.82-10-1.78-14.95a8.31,8.31,0,0,1,1.91-4.07,4.34,4.34,0,0,1,4.11-1.37c1.74.46,2.82,2.16,3.6,3.78a35.68,35.68,0,0,1,3.52,15.3,12.34,12.34,0,0,1-1.67,7.08",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.25,410.29c-1.77,2.53-5.21,1.69-6.81.15s-2.27-3.78-2.88-5.92c-1.41-4.87-2.82-10-1.78-14.95a8.31,8.31,0,0,1,1.91-4.07,4.34,4.34,0,0,1,4.11-1.37c1.74.46,2.82,2.16,3.6,3.78a35.68,35.68,0,0,1,3.52,15.3,12.34,12.34,0,0,1-1.67,7.08",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.61,423.1a15.3,15.3,0,0,0-9.52-1.15,7.83,7.83,0,0,0-4.7,2.1c-1.18,1.29-1.4,3.58,0,4.69a4.41,4.41,0,0,0,3,.75c2.52,0,5.31-.47,7.33,1.05,1.14.86,1.91,2.3,3.28,2.72a3.23,3.23,0,0,0,3.57-1.59,5.55,5.55,0,0,0,.4-4.09A6.25,6.25,0,0,0,140.61,423.1Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.11,413.92a9.23,9.23,0,0,1-1.43-8.47,16.38,16.38,0,0,1,5-7.28,27.11,27.11,0,0,1,9-5.3,9.7,9.7,0,0,1,4-.68,4.24,4.24,0,0,1,3.39,2.05c.95,1.8,0,4-.94,5.77a68.56,68.56,0,0,1-5.9,9c-1.77,2.28-3.79,4.53-6.49,5.56s-5.49.91-6.92-1",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.37,448.45a5.59,5.59,0,0,1-.16-1.15c-.08-.83-.18-1.88-.31-3.13a42.76,42.76,0,0,0-.7-4.61,37,37,0,0,0-1.67-5.43,19.78,19.78,0,0,0-2.78-4.91,10.4,10.4,0,0,0-3.5-2.92,10,10,0,0,0-3-.91,5.91,5.91,0,0,1-1.14-.17,5.48,5.48,0,0,1,1.16,0,9,9,0,0,1,3.08.8,10.34,10.34,0,0,1,3.7,2.94,19.81,19.81,0,0,1,2.88,5,33.56,33.56,0,0,1,1.66,5.52,39.42,39.42,0,0,1,.61,4.66c.1,1.33.14,2.41.15,3.15A5.48,5.48,0,0,1,147.37,448.45Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.15,446a3.85,3.85,0,0,1,0-.54c0-.4,0-.9,0-1.52,0-1.32,0-3.24-.07-5.6-.12-4.74-.53-11.27-1.31-18.44s-1.85-13.64-2.8-18.28c-.23-1.16-.46-2.2-.67-3.12s-.38-1.71-.55-2.35-.26-1.09-.36-1.48a3.17,3.17,0,0,1-.09-.53,2.24,2.24,0,0,1,.19.5c.11.39.26.87.44,1.47s.4,1.42.63,2.33.49,1.95.74,3.11a173.49,173.49,0,0,1,2.94,18.29c.79,7.2,1.14,13.75,1.17,18.49,0,2.37,0,4.29-.08,5.61q-.06.93-.09,1.53A2,2,0,0,1,147.15,446Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.12,433.41a10.31,10.31,0,0,1,0-1.6c.06-1,.2-2.5.49-4.31a61,61,0,0,1,4-13.74,39.79,39.79,0,0,1,7.73-12,18.15,18.15,0,0,1,1.82-1.69c.27-.24.52-.47.77-.66l.71-.48a10,10,0,0,1,1.34-.86,45.22,45.22,0,0,0-4.4,3.92,41.82,41.82,0,0,0-7.53,12,59.14,59.14,0,0,0-2.64,7.38c-.69,2.31-1.15,4.43-1.5,6.22s-.52,3.26-.63,4.28A11.41,11.41,0,0,1,147.12,433.41Z",
    style: {
      fill: "#17324A"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "character-2",
    "data-motion": "breathe",
    "data-delay": 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459.27,222.26s-2.14,9.93-4.64,8.8S433.42,219,433.42,219l-9.89,8.76s32.69,23.34,40.63,18.93S474,227.23,474,227.23Z",
    style: {
      fill: "#ffc7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.53,227.77a92.85,92.85,0,0,1-9.43-3.25c-4.24-1.94-4.07-2.32-3.76-2.78.83-1.22,7.59,3.13,6.68,1.35s-8.89-4.36-8-5.6c1.2-1.62,8.19,3.06,8.81,3.41s1.16-.53.58-.82c-.83-.41-9.45-5-8.28-6.58.64-.89,2.13.42,2.13.42s7.75,4.87,8.27,4.09-3.92-3.8-5.49-4.71-1.76-2-.79-2.36c.66-.24,5.55,2.43,7.08,3.36s5.7,3.58,4.71.61-.64-5.63,0-6.29,1.72-.05,1.61.91a11.68,11.68,0,0,0,.42,3.14,7.25,7.25,0,0,0,1,2.33c.21.33.42.64.62.94a8.89,8.89,0,0,0,3.74,3.07",
    style: {
      fill: "#ffc7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.15,444.71,496,435.5l17.23-.33.32,13.47-1.07.09c-4.75.35-24.19,1.46-27.38.56C481.57,448.28,496.15,444.71,496.15,444.71Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M489,446.71s-5.1,1.58-4.45,2.41,20.34.45,29-.48l0-.39-22.95.65S490,446.73,489,446.71Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M513.82,448.24l-.29,0-.85.07-3.13.2c-2.65.15-6.3.3-10.34.38s-7.71.08-10.35,0l-3.14-.07-.85,0a1.16,1.16,0,0,1-.3,0h4.29c2.64,0,6.3,0,10.34-.1s7.69-.21,10.34-.32l3.13-.13.85,0Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.61,449.17a7.63,7.63,0,0,0-.62-1.49,7.22,7.22,0,0,0-1.09-1.18,2.8,2.8,0,0,1,1.71,2.67Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.64,446.49s-.29-.26-.55-.65-.43-.74-.38-.77.29.26.55.65S495.69,446.45,495.64,446.49Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497,445.72s-.32-.13-.62-.39-.52-.51-.48-.55.31.13.62.39S497.06,445.68,497,445.72Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.88,444.08a2.3,2.3,0,0,1-.9.13.46.46,0,1,1,0-.21A2,2,0,0,1,497.88,444.08Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.16,442.92a1.76,1.76,0,0,1-1,.31,1.79,1.79,0,0,1-1-.11,5,5,0,0,1,1-.09A7,7,0,0,1,498.16,442.92Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495,445a2.9,2.9,0,0,1-1.11,0,6.86,6.86,0,0,1-1.18-.24,2.87,2.87,0,0,1-.68-.26.57.57,0,0,1-.28-.34.42.42,0,0,1,.16-.45,2,2,0,0,1,2.52.55,1.78,1.78,0,0,1,.37.73.69.69,0,0,1,0,.3,3,3,0,0,0-.52-.94,2,2,0,0,0-1-.59,1.73,1.73,0,0,0-1.32.11c-.17.14-.1.34.1.45a3.38,3.38,0,0,0,.62.26,8.42,8.42,0,0,0,1.15.27C494.61,445,495,445,495,445Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.74,445.05a1.1,1.1,0,0,1-.14-.76,1.81,1.81,0,0,1,.29-.82,1.1,1.1,0,0,1,.91-.58.44.44,0,0,1,.35.5,1.18,1.18,0,0,1-.18.5,3.25,3.25,0,0,1-.51.68,1.57,1.57,0,0,1-.62.46s.21-.2.51-.56a3.38,3.38,0,0,0,.45-.67c.15-.24.25-.66,0-.7s-.56.26-.72.48a1.8,1.8,0,0,0-.3.73A4.27,4.27,0,0,0,494.74,445.05Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.38,443.53s-.5,0-1.27.07a5.41,5.41,0,0,0-4.45,3.68c-.25.75-.26,1.25-.3,1.24a1.18,1.18,0,0,1,0-.35,4.31,4.31,0,0,1,.17-.93,5.27,5.27,0,0,1,4.57-3.79,4.13,4.13,0,0,1,.95,0C513.26,443.48,513.38,443.51,513.38,443.53Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.45,436.39a28.62,28.62,0,0,1,.22,3.54,30.29,30.29,0,0,1,0,3.54,28.62,28.62,0,0,1-.22-3.54A30.29,30.29,0,0,1,511.45,436.39Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.13,447a9.47,9.47,0,0,1-2.51.3,10.16,10.16,0,0,1-2.52-.15c0-.06,1.13,0,2.51-.06S505.12,446.92,505.13,447Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.51,446.91s-.09.24-.2.5-.17.49-.23.49-.09-.27,0-.57S508.47,446.87,508.51,446.91Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.75,445.3s-.06.22-.24.41-.35.3-.39.26.06-.22.24-.41S509.71,445.26,509.75,445.3Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.56,444.54c0,.06-.24.06-.49.16s-.43.23-.48.19.09-.28.41-.39S511.58,444.49,511.56,444.54Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.85,444.17c0,.06-.08.15-.22.21s-.27.06-.29,0,.07-.15.21-.21S512.83,444.12,512.85,444.17Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "513.35 443.06 496.12 443.12 496.11 441.04 513.46 441.97 513.35 443.06"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M453.29,441.64l1.44-9.09,17,2.58-2,13.33-1.06-.1c-4.75-.45-24.09-2.63-27.09-4.06C438.31,442.7,453.29,441.64,453.29,441.64Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M445.94,442.41s-5.3.7-4.8,1.63,20,3.87,28.67,4.42l0-.39-22.73-3.24S446.92,442.6,445.94,442.41Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M470.11,448.1h-.3L469,448l-3.12-.33c-2.63-.3-6.26-.77-10.26-1.37s-7.6-1.22-10.21-1.71l-3.08-.6-.83-.17-.29-.08.3,0,.84.13,3.09.54c2.61.44,6.22,1,10.21,1.65s7.62,1.08,10.24,1.42l3.11.4.85.12A1.76,1.76,0,0,1,470.11,448.1Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.08,445.1a8.12,8.12,0,0,0-.36-1.57,6.52,6.52,0,0,0-.88-1.34,2.28,2.28,0,0,1,1.07,1.26A2.4,2.4,0,0,1,447.08,445.1Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.49,443.31c-.05,0-.25-.31-.44-.74a1.86,1.86,0,0,1-.25-.82c.06,0,.25.31.44.74A1.86,1.86,0,0,1,452.49,443.31Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454,442.79s-.28-.19-.54-.49-.42-.59-.38-.63.29.18.54.49S454,442.75,454,442.79Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.1,441.31a2,2,0,0,1-.91,0,2.07,2.07,0,0,1-.88-.23,2,2,0,0,1,.91,0A2,2,0,0,1,455.1,441.31Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.57,440.22a1.84,1.84,0,0,1-1,.14,1.74,1.74,0,0,1-1-.29,5.11,5.11,0,0,1,1,.08A5.18,5.18,0,0,1,455.57,440.22Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.14,441.73a3.1,3.1,0,0,1-1.1-.17,6.17,6.17,0,0,1-1.12-.43,3,3,0,0,1-.63-.38.61.61,0,0,1-.22-.38.44.44,0,0,1,.23-.41,2,2,0,0,1,2.4,1,1.86,1.86,0,0,1,.24.79.65.65,0,0,1,0,.3,3,3,0,0,0-.36-1,2,2,0,0,0-.84-.75,1.69,1.69,0,0,0-1.32-.11c-.2.1-.16.32,0,.46a3.67,3.67,0,0,0,.57.36,9,9,0,0,0,1.09.46C451.73,441.64,452.14,441.7,452.14,441.73Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.85,441.74a1,1,0,0,1,0-.77,1.93,1.93,0,0,1,.42-.76,1.13,1.13,0,0,1,1-.42.44.44,0,0,1,.26.56,1.21,1.21,0,0,1-.26.46,3,3,0,0,1-.62.58,1.53,1.53,0,0,1-.69.35s.25-.16.6-.46a3.56,3.56,0,0,0,.56-.59c.19-.21.35-.61.08-.7s-.59.16-.79.35a1.74,1.74,0,0,0-.41.67A2.79,2.79,0,0,0,451.85,441.74Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.47,443.38s-.48-.12-1.27-.14a5.44,5.44,0,0,0-5,2.88c-.37.69-.47,1.18-.51,1.17a1.1,1.1,0,0,1,.05-.34,5.43,5.43,0,0,1,.33-.89,5.21,5.21,0,0,1,5.14-3,4.2,4.2,0,0,1,.94.17A1.13,1.13,0,0,1,470.47,443.38Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.77,436a28.71,28.71,0,0,1-.38,3.53,27.09,27.09,0,0,1-.59,3.49,32.87,32.87,0,0,1,.39-3.52A31.7,31.7,0,0,1,469.77,436Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.76,445.4a10,10,0,0,1-2.53-.13,9.25,9.25,0,0,1-2.46-.58c0-.06,1.12.18,2.49.37S461.76,445.34,461.76,445.4Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.1,445.9c0,.05-.13.22-.28.46s-.25.45-.31.44,0-.28.14-.55S465.07,445.85,465.1,445.9Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.6,444.52c0,.05-.11.21-.31.36s-.4.24-.43.19.1-.2.31-.36S466.56,444.48,466.6,444.52Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.51,444.08c0,.05-.25,0-.51.07s-.47.15-.51.11.14-.26.47-.32S468.53,444,468.51,444.08Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.84,443.93c0,.06-.1.13-.25.17s-.28,0-.29,0,.1-.13.25-.17S469.83,443.88,469.84,443.93Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "470.52 442.93 453.53 440.07 453.87 438.02 470.81 441.87 470.52 442.93"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "519.11 263.68 518.05 441.89 492.23 441.35 489.96 285.51 474.75 441.89 448.9 437.31 466.97 265.26 519.11 263.68",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.68,265.28a19.09,19.09,0,0,0-.23,3.08c-.07,1.89-.14,4.52-.18,7.41,0,1.45,0,2.82,0,4.09a8,8,0,0,0,.55,3.35,3.75,3.75,0,0,0,1.53,1.73,1.4,1.4,0,0,0,.81.25s-.28-.12-.71-.42a3.78,3.78,0,0,1-1.29-1.7,8.18,8.18,0,0,1-.42-3.21c0-1.27.05-2.64.08-4.08,0-2.9,0-5.52,0-7.42A18.47,18.47,0,0,0,487.68,265.28Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.78,267.3c0,.06.36.3.37.92a1,1,0,0,1-.39.85.93.93,0,0,1-1.07-.08.81.81,0,0,1-.06-1.34,1.12,1.12,0,0,1,1.08-.26l0-.2c-.22.11-.34.19-.32.23s.15,0,.39,0l.21,0-.2-.15a1.26,1.26,0,0,0-1.45.11,1.26,1.26,0,0,0,0,2.1,1.4,1.4,0,0,0,1.66,0,1.35,1.35,0,0,0,.46-1.27,1.21,1.21,0,0,0-.43-.77C491.91,267.28,491.79,267.28,491.78,267.3Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.9,151.5a1.61,1.61,0,0,0,2.27,1.9c1.06-.53,1.19-2,1-3.17s-.61-2.42-.12-3.5a8.06,8.06,0,0,1,1.82-2,5.11,5.11,0,0,0,1.43-4.35,4.3,4.3,0,0,0-3-3.39c-1.56-.44-3.48,0-4.64-1.09-.84-.82-.89-2.16-1.54-3.13-1-1.52-3.14-1.76-4.95-1.51s-3.64.82-5.4.38c-1.48-.36-2.69-1.39-4.07-2a8,8,0,0,0-10.38,10.94,5.07,5.07,0,0,0,2.47,2.45",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M507.9,151.5a1.61,1.61,0,0,0,2.27,1.9c1.06-.53,1.19-2,1-3.17s-.61-2.42-.12-3.5a8.06,8.06,0,0,1,1.82-2,5.11,5.11,0,0,0,1.43-4.35,4.3,4.3,0,0,0-3-3.39c-1.56-.44-3.48,0-4.64-1.09-.84-.82-.89-2.16-1.54-3.13-1-1.52-3.14-1.76-4.95-1.51s-3.64.82-5.4.38c-1.48-.36-2.69-1.39-4.07-2a8,8,0,0,0-10.38,10.94,5.07,5.07,0,0,0,2.47,2.45"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M498.93,189.93h0a9,9,0,0,1-9-9.1l.12-8.55s-7.19-.72-7.66-7.84-.14-23.54-.14-23.54h0a24.82,24.82,0,0,1,25,1.77l1.1.76-.54,37.66A9,9,0,0,1,498.93,189.93Z",
    style: {
      fill: "#ffc7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.18,153.79a1.07,1.07,0,0,0,0-2.12H484a1.07,1.07,0,0,0,0,2.12A.49.49,0,0,0,484.18,153.79Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.78,151.81c.12.11.79-.46,1.77-.52s1.72.41,1.83.28-.08-.28-.4-.5a2.45,2.45,0,0,0-2.87.19C482.82,151.52,482.73,151.75,482.78,151.81Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.13,151.76a1,1,0,0,0,1.18,1.71,1,1,0,1,0-1.18-1.71Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.49,151.81c.12.11.79-.46,1.77-.52s1.72.41,1.82.28-.07-.28-.4-.5a2.44,2.44,0,0,0-2.86.19C493.52,151.52,493.43,151.75,493.49,151.81Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490,160.11a5.16,5.16,0,0,0-1.6-.25c-.26,0-.46-.06-.49-.19a1.48,1.48,0,0,1,.14-.75l.67-2a28,28,0,0,0,1.4-5.34,27.58,27.58,0,0,0-1.93,5.17c-.22.7-.42,1.38-.63,2.05a1.72,1.72,0,0,0-.08,1.07.67.67,0,0,0,.47.39,1.74,1.74,0,0,0,.44,0A4.6,4.6,0,0,0,490,160.11Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.07,172.18a16.57,16.57,0,0,0,9.14-3.15s-1.91,5.25-9.06,5Z",
    style: {
      fill: "#e8a7a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.24,142.7s4.3,2.19,10-.52c3.74-1.78,8.08-2.6,9-1.84s1.07,4.59,4.72,5.78c0,0-.4,7.28,2.51,7.08s1.32-11.53,1.32-11.53l-7-3.61L495,136.45l-7.33.88L482,138.77Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M482.24,142.7s4.3,2.19,10-.52c3.74-1.78,8.08-2.6,9-1.84s1.07,4.59,4.72,5.78c0,0-.4,7.28,2.51,7.08s1.32-11.53,1.32-11.53l-7-3.61L495,136.45l-7.33.88L482,138.77Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M508,150.85c.12,0,4.82-1.71,4.93,3.17s-4.81,4-4.82,3.84S508,150.85,508,150.85Z",
    style: {
      fill: "#ffc7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.52,156s.08.06.23.12a.84.84,0,0,0,.63,0,2.1,2.1,0,0,0,.93-1.91,2.79,2.79,0,0,0-.26-1.21,1,1,0,0,0-.66-.64.43.43,0,0,0-.49.25c-.07.13,0,.23-.06.24s-.1-.08-.07-.28a.5.5,0,0,1,.19-.31.64.64,0,0,1,.46-.14,1.2,1.2,0,0,1,.91.74,2.81,2.81,0,0,1,.32,1.35,2.21,2.21,0,0,1-1.19,2.14.9.9,0,0,1-.78-.12C509.53,156.1,509.5,156,509.52,156Z",
    style: {
      fill: "#e8a7a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.45,135.58a2.29,2.29,0,0,0-1.7.07,2.21,2.21,0,0,0-1.32,1.06,8,8,0,0,1,1.41-.84A8.48,8.48,0,0,1,510.45,135.58Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.51,132.66c-.08,0,.05,1-.12,2.25a9.8,9.8,0,0,1-.68,2.13,1.7,1.7,0,0,0,.41-.54,4.77,4.77,0,0,0,.51-1.55A5,5,0,0,0,507.51,132.66Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M510.45,135.58a2.29,2.29,0,0,0-1.7.07,2.21,2.21,0,0,0-1.32,1.06,8,8,0,0,1,1.41-.84A8.48,8.48,0,0,1,510.45,135.58Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M507.51,132.66c-.08,0,.05,1-.12,2.25a9.8,9.8,0,0,1-.68,2.13,1.7,1.7,0,0,0,.41-.54,4.77,4.77,0,0,0,.51-1.55A5,5,0,0,0,507.51,132.66Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M518.17,226.81l10.48.42s6.85-36.9-9.16-43.19a40.66,40.66,0,0,0-9.84-1.8l.17-6.23s-9.39.87-11.89,6.91c0,0-3.11-7.13-9.15-7.72l0,6.77c-3.59.2-13.28,3.3-14,3.69a10.76,10.76,0,0,0-6.38,6.53c-1,2.62,3.11,19.77,3.11,19.77l1.13,25-3.27,28.23,50-1.29-1.18-25.52-.17-22.2",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.44,195.65c0-.06-.4-.24-.88.17a1.19,1.19,0,0,0-.4,1,1.15,1.15,0,0,0,.92.95,1.13,1.13,0,0,0,1.24-.46,1.19,1.19,0,0,0,.07-1.06c-.25-.58-.73-.6-.72-.54s.28.22.37.66a.81.81,0,0,1-.12.67.69.69,0,0,1-.72.23.71.71,0,0,1-.56-.52.82.82,0,0,1,.19-.66C493.1,195.72,493.44,195.73,493.44,195.65Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.52,214.25c0-.05-.4-.24-.88.18a1.15,1.15,0,1,0,1.76,1.48,1.21,1.21,0,0,0,.07-1.07c-.26-.58-.73-.6-.72-.53s.28.21.37.65a.88.88,0,0,1-.12.68.71.71,0,0,1-.73.22.67.67,0,0,1-.55-.52.86.86,0,0,1,.18-.66C491.18,214.33,491.52,214.33,491.52,214.25Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.34,232.41s-.4-.24-.89.18a1.15,1.15,0,1,0,1.76,1.48,1.18,1.18,0,0,0,.08-1.07c-.26-.58-.73-.6-.72-.53s.27.21.37.65a.92.92,0,0,1-.12.68.71.71,0,0,1-.73.22.7.7,0,0,1-.56-.52.86.86,0,0,1,.19-.66C490,232.49,490.33,232.49,490.34,232.41Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.14,252.18c0-.06-.4-.24-.88.17a1.18,1.18,0,0,0-.4,1,1.21,1.21,0,0,0,2.16.5,1.19,1.19,0,0,0,.07-1.06c-.26-.58-.73-.61-.72-.54s.28.21.37.65a.83.83,0,0,1-.12.68.67.67,0,0,1-.72.22.69.69,0,0,1-.56-.51.87.87,0,0,1,.18-.67C488.8,252.25,489.14,252.26,489.14,252.18Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.2,262a4,4,0,0,0,.08-.81c0-.57.08-1.34.13-2.3.1-2.06.25-5,.42-8.5.37-7.16,1-17.06,1.81-28s1.72-20.8,2.35-27.95c.31-3.54.56-6.42.74-8.47.07-1,.13-1.73.17-2.31a4,4,0,0,0,0-.8,4.39,4.39,0,0,0-.13.79c-.07.58-.16,1.34-.28,2.3-.22,2.05-.52,4.92-.9,8.45-.72,7.15-1.66,17-2.5,27.95s-1.38,20.83-1.65,28c-.14,3.59-.23,6.49-.26,8.5q0,1.44,0,2.31A5,5,0,0,0,492.2,262Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.81,146.69c-.21.39-1.33.19-2.63.23s-2.41.24-2.63-.14c-.1-.18.08-.52.55-.83a4.06,4.06,0,0,1,4.13-.07C498.7,146.18,498.9,146.5,498.81,146.69Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.34,146.62c-.18.4-1.13.36-2.21.39s-2,.07-2.22-.32.74-1.23,2.2-1.24S487.54,146.25,487.34,146.62Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.48,160.55c-.1.12-.6-.14-1.26-.14s-1.18.23-1.27.11.41-.65,1.27-.63S496.58,160.45,496.48,160.55Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.28,160.08c.06,0,.06.33-.12.79a3.49,3.49,0,0,1-1.23,1.48,3.38,3.38,0,0,1-1.82.62c-.5,0-.79-.1-.78-.17a8.34,8.34,0,0,0,2.3-.88C494.77,161.16,495.13,160,495.28,160.08Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.49,186.27s-4.87,1.58-8.63,13.24a180.51,180.51,0,0,0-5.59,22.75l14.71,5,5.49-33.49Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.45,259a11.34,11.34,0,0,0,2.81,1.44,7.53,7.53,0,0,0,2.48.52h1.12a8.81,8.81,0,0,0,4.66-1.32c6.15-3.81,24.7-15.38,27.85-18.3,3.78-3.52,11.48-39.86,11.48-39.86l15.8,1.63s-6.24,32.19-13,46.42c-4.28,9.05-40.56,23.21-40.59,23.23a94.94,94.94,0,0,1-8,5.9c-4,2.39-4.23,2-4.43,1.52-.53-1.39,6.89-4.47,4.91-4.73s-8.64,4.83-9.14,3.36c-.64-1.91,7.19-5,7.83-5.31s.22-1.25-.35-.94c-.81.45-9.47,4.94-10.13,3.06-.36-1,1.56-1.51,1.56-1.51s8.42-3.6,8.08-4.48-5.36,1.07-7,1.84-2.65.31-2.39-.69c.17-.68,5.15-3.18,6.79-3.91s6.19-2.65,3.18-3.53-5-2.68-5.19-3.54A1,1,0,0,1,462.45,259Z",
    style: {
      fill: "#ffc7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.49,184s-7.16,2.8-8.91,12.64-5.86,27.4-5.86,27.4l23.93,3.15S536.26,185.86,519.49,184Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.65,227.23a1.26,1.26,0,0,1-.46,0l-1.3-.12-4.81-.54-16.11-2-.26,0,0-.28c.14-.81.28-1.67.42-2.54,1.15-6.92,2.22-13.18,3-17.71.4-2.21.73-4,1-5.36.11-.58.21-1.06.29-1.45a2,2,0,0,1,.13-.5,1.71,1.71,0,0,1,0,.52c-.05.39-.12.88-.19,1.47-.21,1.35-.48,3.17-.81,5.38-.71,4.55-1.72,10.82-2.86,17.74-.15.88-.29,1.74-.43,2.55L506,224l16.08,2.18,4.79.7,1.29.22A2.07,2.07,0,0,1,528.65,227.23Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.74,238.72c-.15,0-.26-8.6-.26-19.2s.11-19.21.26-19.21.26,8.6.26,19.21S472.88,238.72,472.74,238.72Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.87,223.4c-.06,0,0-.52.48-1.15a3.39,3.39,0,0,1,2.7-1.3l-.15.47h0a4.53,4.53,0,0,1-1.74-2.45c-.2-.75-.12-1.24-.06-1.24s.14.46.41,1.12a5,5,0,0,0,1.69,2.14h0l.65.48H427a3.43,3.43,0,0,0-2.42,1C424.12,223,424,223.43,423.87,223.4Z",
    style: {
      fill: "#e8a7a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.06,201s0,0-.16.08a2.91,2.91,0,0,1-.48.16,5.89,5.89,0,0,1-2,.19c-1.75-.1-4.1-1.06-6.88-2.31a17.5,17.5,0,0,0-4.68-1.53,14.94,14.94,0,0,0-5.63.16c-3.94.76-8,2.71-12.46,4.1A22.19,22.19,0,0,1,491,203a17.7,17.7,0,0,1-6.26-1.31c-3.79-1.47-7-3.32-9.91-4.09a14.06,14.06,0,0,0-7.08-.39,13.36,13.36,0,0,0-2.46.93,4.5,4.5,0,0,1,.58-.38,8.17,8.17,0,0,1,1.83-.74,13.74,13.74,0,0,1,7.23.23c3,.74,6.23,2.57,10,4a17.28,17.28,0,0,0,6.1,1.25,22,22,0,0,0,6.61-1.09c4.43-1.37,8.49-3.32,12.52-4.08a15.73,15.73,0,0,1,5.79-.11,17.83,17.83,0,0,1,4.77,1.62c2.76,1.3,5,2.29,6.74,2.45A7.75,7.75,0,0,0,530.06,201Z",
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.52,220.34c0,.08-.74-.27-1.95-.6a12.75,12.75,0,0,0-9.4,1.09c-1.1.6-1.7,1.1-1.76,1a5,5,0,0,1,1.57-1.34,11.51,11.51,0,0,1,4.73-1.66,11.34,11.34,0,0,1,5,.53A5,5,0,0,1,472.52,220.34Z",
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.54,228.44s-.37-.31-1.11-.74a8.25,8.25,0,0,0-3.43-1,14.92,14.92,0,0,0-5.31.65c-2,.52-4.08,1.35-6.44,1.8a22.05,22.05,0,0,1-6.71.33,18.18,18.18,0,0,1-5.3-1.43,18.79,18.79,0,0,1-3.22-1.83,5.51,5.51,0,0,1-1-.87,37,37,0,0,0,4.4,2.36,18.38,18.38,0,0,0,5.21,1.29,22.46,22.46,0,0,0,6.56-.36c2.31-.43,4.42-1.25,6.42-1.76a14.35,14.35,0,0,1,5.47-.54,7.71,7.71,0,0,1,3.5,1.22,4.58,4.58,0,0,1,.78.64C505.48,228.33,505.56,228.43,505.54,228.44Z",
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.32,245.87c0,.09-1.43,0-3.72.23a35.85,35.85,0,0,0-8.73,1.86,35,35,0,0,0-8,4c-1.9,1.29-3,2.23-3,2.16a4.2,4.2,0,0,1,.7-.73,25.66,25.66,0,0,1,2.13-1.73,30.93,30.93,0,0,1,8-4.24,31.51,31.51,0,0,1,8.88-1.74,21.57,21.57,0,0,1,2.74,0A3.38,3.38,0,0,1,494.32,245.87Z",
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.11,258a8.29,8.29,0,0,1-5-.07,8.42,8.42,0,0,1-4.32-2.46,27.14,27.14,0,0,0,4.45,2A25.12,25.12,0,0,0,519.11,258Z",
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.7,218.23a7,7,0,0,0-3.36-.22,13.48,13.48,0,0,0-3.48,1.24,22.41,22.41,0,0,1-4.3,1.75,14.29,14.29,0,0,1-8.37-.4,13.45,13.45,0,0,1-2.3-1.11c-.51-.33-.77-.54-.75-.57s1.15.68,3.17,1.33a15,15,0,0,0,8.12.25,24.54,24.54,0,0,0,4.23-1.69,12.79,12.79,0,0,1,3.62-1.16,6.07,6.07,0,0,1,2.57.16A2,2,0,0,1,529.7,218.23Z",
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.26,183.16a4.93,4.93,0,0,1-1.08.55l-3,1.32a20.58,20.58,0,0,1-4.67,1.55,8.15,8.15,0,0,1-2.95-.05c-1-.2-2-.54-3-.81a16.93,16.93,0,0,0-5.86-.24,15.24,15.24,0,0,1-4.91-.22,6.41,6.41,0,0,1-2.95-1.53,3.61,3.61,0,0,1-.58-.7c-.11-.18-.16-.27-.15-.28s.28.34.86.83a6.65,6.65,0,0,0,2.9,1.32,15.37,15.37,0,0,0,4.8.1,16.49,16.49,0,0,1,6,.22c1,.27,2,.61,3,.81a7.68,7.68,0,0,0,2.78.07,21.57,21.57,0,0,0,4.6-1.41l3.07-1.17A6,6,0,0,1,515.26,183.16Z",
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.71,180.54a2.46,2.46,0,0,1,1.76.23,2.94,2.94,0,0,1,1.25,1.45,7,7,0,0,1,.39,1.12c.06.2.11.41.17.62a1.54,1.54,0,0,0,.33.72.73.73,0,0,0,.46.23.93.93,0,0,0,.44-.09c.24-.1.41-.19.61-.28l1.1-.55,1.86-.94a7.23,7.23,0,0,0,1.65-1,6.81,6.81,0,0,0-1.81.66l-1.9.84-1.12.52-.58.26c-.18.07-.25.06-.33,0a3.94,3.94,0,0,1-.38-1.12,7.35,7.35,0,0,0-.46-1.19,3.17,3.17,0,0,0-1.51-1.57,2.2,2.2,0,0,0-1.46-.17C499.84,180.37,499.7,180.52,499.71,180.54Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.68,181.59a28.73,28.73,0,0,0,4.08,3.38l.33.25.08-.41.09-.54a6.21,6.21,0,0,1,1.53-3.59,5.38,5.38,0,0,1,1.39-.88,2,2,0,0,0-1.64.6,4.37,4.37,0,0,0-1.16,1.55,9.35,9.35,0,0,0-.63,2.23l-.09.54.41-.17A28.85,28.85,0,0,0,488.68,181.59Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M509.73,182.06s-6.35,6.55-7.24,5.58-1.27-7.27-3.86-6a2.47,2.47,0,0,1,1.6-1.15c1-.1,2.57-.25,3.36,3.35,0,0,0,1.12.85.79S509.73,182.06,509.73,182.06Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M497,181.17a1.74,1.74,0,0,0-1.67,1.39,40.53,40.53,0,0,0-.43,5.18l-5.64-5.57,3.7,2.57s.5-4.38,3.24-4.94Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "character-1",
    "data-motion": "breathe",
    "data-delay": 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.75,182.28l17.09-2.35c0-2-.6-9.75-.6-9.75s7.08-1.52,6.76-8.67-2.49-23.46-2.49-23.46h0a24.85,24.85,0,0,0-24.75,4.55l-1,.88Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.57,150.41a1,1,0,1,1,1.46-.15A1,1,0,0,1,280.57,150.41Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.2,148.68c-.1.13-.83-.37-1.81-.32s-1.67.6-1.79.48,0-.28.34-.53a2.42,2.42,0,0,1,2.88-.13C282.14,148.4,282.26,148.62,282.2,148.68Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.93,150.19a1,1,0,1,1-1.41.42A1,1,0,0,1,270.93,150.19Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.57,150.16c-.1.13-.83-.37-1.82-.32s-1.66.6-1.78.48,0-.28.34-.54a2.41,2.41,0,0,1,1.42-.54,2.51,2.51,0,0,1,1.46.41C271.51,149.88,271.63,150.1,271.57,150.16Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276,158a5,5,0,0,1,1.57-.42c.26-.05.45-.12.47-.26a1.48,1.48,0,0,0-.23-.72l-.89-2a26.28,26.28,0,0,1-2-5.15,27.92,27.92,0,0,1,2.49,4.93l.85,2a1.64,1.64,0,0,1,.2,1.06.68.68,0,0,1-.42.44,1.52,1.52,0,0,1-.43.08A4.66,4.66,0,0,1,276,158Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.85,159.31a18.28,18.28,0,0,0,4.9,1.13,2.72,2.72,0,0,1-3.15,1.26C272.42,161,272.85,159.31,272.85,159.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.25,170.07a16.6,16.6,0,0,1-9.46-2.11s2.49,5,9.58,4Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.76,139.84s-4,2.65-10,.59c-3.93-1.36-8.34-1.69-9.19-.82s-.55,4.68-4.05,6.27c0,0,1.2,7.21-1.72,7.33s-2.59-11.33-2.59-11.33l6.61-4.38,7.51-2.47,7.4.07,5.83.8Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.05,150.82c-.13,0-5-1.17-4.56,3.7s5.24,3.43,5.24,3.29S257.05,150.82,257.05,150.82Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.07,156.1s-.08.07-.21.15a.87.87,0,0,1-.64.06,2.12,2.12,0,0,1-1.14-1.79,3,3,0,0,1,.13-1.24,1,1,0,0,1,.58-.71.43.43,0,0,1,.52.19c.08.13.06.23.09.24s.09-.09,0-.29a.54.54,0,0,0-.22-.29.65.65,0,0,0-.48-.08,1.18,1.18,0,0,0-.82.83,3,3,0,0,0-.18,1.39,2.21,2.21,0,0,0,1.43,2,.88.88,0,0,0,.76-.2C256.07,156.22,256.09,156.11,256.07,156.1Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.33,147.35c.18.28,1.1,0,2.22-.11s2.07,0,2.19-.34-.89-1-2.31-.81S277.15,147.1,277.33,147.35Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.38,148c.18.28,1.1,0,2.21-.11s2.08,0,2.19-.33-.89-1-2.3-.81S266.2,147.73,266.38,148Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.82,140.73a17.11,17.11,0,0,1-2.65,3.45,5.64,5.64,0,0,1-3.92,1.63,3.44,3.44,0,0,1-3.24-2.45,2.51,2.51,0,0,1,2.26-3,1.52,1.52,0,1,1,.38-2.84c-1.26,0-1.76-1.9-.93-2.85a3.64,3.64,0,0,1,3.49-.79,22.49,22.49,0,0,0,3.67.8c2,0,3.76-1.1,5.25-2.39a23.07,23.07,0,0,1,4.63-3.64,11,11,0,0,1,7.09-.56,11.34,11.34,0,0,1,5.36,2.56A6.68,6.68,0,0,1,284.5,136a4.78,4.78,0,0,1-3.61,4.28,12.92,12.92,0,0,1-8.45-.72c-4.11-2-11.64-.21-11.64-.21Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.7,188.57s7-6.53,11.64-8.51a25.08,25.08,0,0,1,7.5-1.88h0a30.41,30.41,0,0,0,18.29-1c1.05.08,2.64.12,4.75.29A26.71,26.71,0,0,1,301.34,187l14.52,17.45-14.64,14.64-3.29-5.4s4.88,41.78,5.08,47.7L249,267l-.3-47.9Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.31,234.93s.11-.13.34-.32l1-.85,3.88-3c3.29-2.55,7.85-6,12.91-9.87l1.39-1-.05.36a135.54,135.54,0,0,1-8-12.8c-.93-1.6-1.7-2.91-2.27-3.9a9.3,9.3,0,0,1-.8-1.44,1.61,1.61,0,0,1,.27.33c.16.23.4.56.69,1,.59.88,1.41,2.18,2.41,3.82,2,3.24,4.6,7.89,8.12,12.67l.15.2-.2.16-1.4,1c-5.06,3.83-9.65,7.28-13,9.75l-4,2.91-1.09.77A2,2,0,0,1,246.31,234.93Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.24,189.82a2.14,2.14,0,0,1,.73-.38,6.43,6.43,0,0,1,2.22-.4,10.12,10.12,0,0,1,6.77,2.79,19.84,19.84,0,0,1,4.17,6.07,14.49,14.49,0,0,1,1.14,2.82,21.61,21.61,0,0,1-1.47-2.65,22,22,0,0,0-4.2-5.86,10.25,10.25,0,0,0-6.42-2.8A11.68,11.68,0,0,0,239.24,189.82Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.12,178.24a10.38,10.38,0,0,1-2.56,1,25.81,25.81,0,0,1-13.21.4,10,10,0,0,1-2.62-.87,25.34,25.34,0,0,1,2.69.51,32.47,32.47,0,0,0,6.54.5,32,32,0,0,0,6.5-.9A25.3,25.3,0,0,1,277.12,178.24Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.15,441l-1.7,6.83s-11.71,14.52-15.32,13.81c-2.37-.46.54-4.25,5-15.28l.94-4.55Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.65,459.45a.48.48,0,0,0,.1.2,1.2,1.2,0,0,0,.49.44,2,2,0,0,0,1,.22,2.8,2.8,0,0,0,1.32-.46,56.65,56.65,0,0,0,5.9-5.25,73.07,73.07,0,0,0,5.24-5.86c.62-.78,1.11-1.43,1.44-1.88l.37-.53.12-.19a1.46,1.46,0,0,0-.16.17l-.41.5-1.49,1.84c-1.28,1.53-3.11,3.62-5.27,5.8a66.2,66.2,0,0,1-5.82,5.27,2.27,2.27,0,0,1-2.24.3A1.57,1.57,0,0,1,216.65,459.45Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.31,454.78s.37,0,.95.05a5.62,5.62,0,0,1,2.1.76,4.19,4.19,0,0,1,1.58,1.51c.28.49.36.83.4.82a1.93,1.93,0,0,0-.25-.89,4,4,0,0,0-1.6-1.63,5.33,5.33,0,0,0-2.22-.73A1.93,1.93,0,0,0,218.31,454.78Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.39,451.37s-.12-.49-.21-1.28a5,5,0,0,1,.58-3,5.15,5.15,0,0,1,2.24-2.16,8.43,8.43,0,0,1,1.27-.44,1.3,1.3,0,0,0-.37,0,3.61,3.61,0,0,0-1,.28,5,5,0,0,0-2.92,5.31,5.44,5.44,0,0,0,.24.94A1,1,0,0,0,229.39,451.37Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.4,442.11a6.68,6.68,0,0,0-.64,2.14c-.22,1.21-.45,2.17-.4,2.19a6.79,6.79,0,0,0,.62-2.15C233.2,443.08,233.46,442.13,233.4,442.11Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.92,447.28c0,.06.66,0,1.45.22s1.37.46,1.4.41a2.49,2.49,0,0,0-1.35-.63A2.64,2.64,0,0,0,221.92,447.28Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.68,448.45c0,.06.56,0,1.21.16s1.12.43,1.16.38a2.35,2.35,0,0,0-2.37-.54Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.74,449.92a6.51,6.51,0,0,1,1.26,0,6.83,6.83,0,0,1,1.16.48,1.54,1.54,0,0,0-1.11-.69A1.58,1.58,0,0,0,220.74,449.92Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.72,446.79a1.4,1.4,0,0,0,.39-.05,7.05,7.05,0,0,0,1-.26,9.31,9.31,0,0,0,1.46-.62c.26-.14.53-.3.8-.48a1.12,1.12,0,0,0,.59-.86.69.69,0,0,0-.9-.53,1.89,1.89,0,0,0-.81.52,13.6,13.6,0,0,0-1.08,1.12c-.28.33-.5.62-.64.82s-.21.32-.19.32.36-.4,1-1c.3-.32.67-.69,1.1-1.07a1.59,1.59,0,0,1,.72-.46c.26-.07.6.07.61.33s-.25.51-.49.68-.52.33-.78.47a11.24,11.24,0,0,1-1.41.65C223.26,446.64,222.71,446.75,222.72,446.79Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.34,446.64a1.12,1.12,0,0,0,0-.34c0-.22,0-.53-.07-.93a5.1,5.1,0,0,0-.37-1.35,3,3,0,0,0-.46-.71.81.81,0,0,0-.94-.29.86.86,0,0,0-.32.9,3.4,3.4,0,0,0,.25.8,4.08,4.08,0,0,0,.84,1.15,5.39,5.39,0,0,0,.74.6c.19.13.31.19.32.17s-.4-.3-.94-.88a4.22,4.22,0,0,1-.76-1.12,2.72,2.72,0,0,1-.23-.75c0-.25,0-.56.21-.67s.48,0,.66.23a3.16,3.16,0,0,1,.44.66,5.38,5.38,0,0,1,.4,1.29A9.09,9.09,0,0,0,223.34,446.64Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.34,444.4l.05-9.11-17.88-.21-.22,13.34,1.1.08c4.93.32,25.1,1.29,28.41.37C307.49,447.85,292.34,444.4,292.34,444.4Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274,448l.31,0,.88.06,3.25.17c2.74.13,6.53.26,10.72.31s8,0,10.74,0l3.25-.09.88,0,.31,0a1.5,1.5,0,0,0-.31,0h-.88l-3.26,0c-2.74,0-6.53,0-10.72,0s-8-.16-10.73-.25l-3.25-.11-.88,0Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.88,446.16c.05,0,.3-.26.57-.64s.44-.73.39-.77-.3.26-.57.65S292.83,446.13,292.88,446.16Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.44,445.41s.32-.13.64-.39.53-.51.49-.55-.33.13-.64.4S291.4,445.37,291.44,445.41Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.55,443.79a2.05,2.05,0,0,0,.93.13,2.37,2.37,0,0,0,.93-.08,2,2,0,0,0-.93-.13A2.37,2.37,0,0,0,290.55,443.79Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.25,442.65a2.76,2.76,0,0,0,2.11.18,6,6,0,0,0-1.06-.08A6.61,6.61,0,0,0,290.25,442.65Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.5,444.68a3.63,3.63,0,0,0,1.15,0,7.35,7.35,0,0,0,1.23-.24,3.59,3.59,0,0,0,.7-.27.55.55,0,0,0,.29-.34.42.42,0,0,0-.17-.44,2.16,2.16,0,0,0-2.61.56,1.83,1.83,0,0,0-.38.73.64.64,0,0,0,0,.29,3.29,3.29,0,0,1,.54-.93,2.14,2.14,0,0,1,1-.6,1.86,1.86,0,0,1,1.37.11c.18.13.1.34-.1.45a3.64,3.64,0,0,1-.65.25,7.42,7.42,0,0,1-1.19.28C293.94,444.65,293.5,444.65,293.5,444.68Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.8,444.74a1,1,0,0,0,.14-.76,1.72,1.72,0,0,0-.3-.81,1.17,1.17,0,0,0-.95-.57.45.45,0,0,0-.36.51,1.26,1.26,0,0,0,.19.49,3.91,3.91,0,0,0,.53.67,1.62,1.62,0,0,0,.66.45s-.23-.2-.54-.55a4,4,0,0,1-.48-.66c-.15-.24-.25-.66,0-.7s.57.25.75.47a1.85,1.85,0,0,1,.31.72A4.3,4.3,0,0,1,293.8,444.74Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.47,443.35s.51,0,1.32.06a6,6,0,0,1,2.86,1.17,5.47,5.47,0,0,1,1.77,2.46c.26.73.28,1.22.33,1.22a1,1,0,0,0,0-.35,5,5,0,0,0-.18-.92,5.3,5.3,0,0,0-1.78-2.57,5.66,5.66,0,0,0-3-1.15,5.09,5.09,0,0,0-1,0A1.16,1.16,0,0,0,274.47,443.35Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.41,436.27a56.11,56.11,0,0,0-.18,7,28.43,28.43,0,0,0,.2-3.51A28.13,28.13,0,0,0,276.41,436.27Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,446.72a10.88,10.88,0,0,0,2.61.28,11,11,0,0,0,2.62-.17c0-.06-1.18,0-2.62,0S283.05,446.66,283,446.72Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.54,446.67c-.05,0,.09.24.21.5s.18.48.24.48.09-.27,0-.57S279.58,446.63,279.54,446.67Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.24,445.09s.07.22.25.4.37.29.41.25-.07-.22-.25-.4S278.28,445.05,278.24,445.09Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.36,444.35c0,.06.25.06.51.15s.45.22.5.19-.1-.28-.43-.39S276.34,444.29,276.36,444.35Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,444c0,.06.08.14.23.2s.28.06.3,0-.08-.14-.22-.2S275,443.94,275,444Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "304.75 258.06 296.16 440.48 268.32 441.03 272.94 292.76 241.63 442.17 215.16 442.17 250.51 263.37",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.86,266.14a2,2,0,0,1,.06.72,9.27,9.27,0,0,1-.28,2,10.61,10.61,0,0,1-9.39,8,9.33,9.33,0,0,1-2,0,2.05,2.05,0,0,1-.71-.17c0-.1,1,.06,2.65-.16a10.89,10.89,0,0,0,9.07-7.74C261.76,267.16,261.76,266.13,261.86,266.14Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.06,264.31a3.57,3.57,0,0,1,.06,1c0,.67,0,1.63,0,2.82-.06,2.39-.17,5.68-.32,9.31a19.83,19.83,0,0,1-.59,5.15,5.52,5.52,0,0,1-2.85,3.13,12.73,12.73,0,0,1-2.69,1,4.19,4.19,0,0,1-1,.18,4.27,4.27,0,0,1,1-.38,15.16,15.16,0,0,0,2.56-1.08,5.22,5.22,0,0,0,2.57-3,20.33,20.33,0,0,0,.53-5c.15-3.63.32-6.92.47-9.3.08-1.19.15-2.15.21-2.82A4.73,4.73,0,0,1,281.06,264.31Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.59,266.7s.08-.14.32-.24a1.66,1.66,0,0,1,1.11,0,1.9,1.9,0,0,1,1.2,1.15,1.9,1.9,0,0,1-2.66,2.2,1.9,1.9,0,0,1-.9-1.41,1.58,1.58,0,0,1,.21-1.08c.14-.23.28-.3.3-.28a2.32,2.32,0,0,0-.15,1.3,1.61,1.61,0,0,0,.77,1.05,1.36,1.36,0,0,0,1.47-.24,1.38,1.38,0,0,0,.51-1.39,1.62,1.62,0,0,0-.88-1A2.44,2.44,0,0,0,275.59,266.7Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.15,418.37c-.09.11-.88-.43-1.75-1.2s-1.5-1.48-1.41-1.59.88.43,1.75,1.2S229.25,418.26,229.15,418.37Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.17,396.61a10.94,10.94,0,0,1-1.77,2.93,11.69,11.69,0,0,1-2.2,2.63,23.1,23.1,0,0,1,4-5.56Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.39,383.13a13.54,13.54,0,0,1-1.21-5.15,13.54,13.54,0,0,1,1.21,5.15Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.31,360.51a18.7,18.7,0,0,1-4.76,4,9.32,9.32,0,0,1,2.22-2.19A9.53,9.53,0,0,1,251.31,360.51Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.36,348.21a12.2,12.2,0,0,1-1.24-3.3,11.87,11.87,0,0,1-.74-3.45,12.2,12.2,0,0,1,1.24,3.3A11.93,11.93,0,0,1,245.36,348.21Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.23,324a14,14,0,0,1-2.85,2.54,14.38,14.38,0,0,1-3.18,2.13,28.42,28.42,0,0,1,6-4.67Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.5,308.93a9.9,9.9,0,0,1-1.26-4.07,9.78,9.78,0,0,1,.07-4.26c.16,0,.11,1.9.44,4.19S252.65,308.88,252.5,308.93Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.82,289.09a9.27,9.27,0,0,1,0-4.36,9.27,9.27,0,0,1,0,4.36Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.3,298.34a5.65,5.65,0,0,1-2.2-5.67c.16,0,.14,1.4.76,3S287.41,298.23,287.3,298.34Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.54,285.52a6,6,0,0,1,.35-2.44,5.92,5.92,0,0,1,.84-2.32,11.51,11.51,0,0,1-1.19,4.76Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287,324.81a39.51,39.51,0,0,1-2.4-8.72,19.52,19.52,0,0,1,1.45,4.29A20.71,20.71,0,0,1,287,324.81Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.58,309c.09.11-.82,1-2,2a7.84,7.84,0,0,1-2.36,1.56c-.09-.11.82-1,2-2A7.86,7.86,0,0,1,298.58,309Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.86,352.56a12.8,12.8,0,0,1-3-2.17,13,13,0,0,1-2.62-2.56,26,26,0,0,1,5.58,4.73Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.35,339.86c0,.16-1.35.4-2.77,1.29s-2.25,2-2.38,1.9a5.66,5.66,0,0,1,5.15-3.19Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.69,373.58a18.77,18.77,0,0,1,.51-4.41,19.3,19.3,0,0,1,1-4.32,37.36,37.36,0,0,1-1.54,8.73Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.41,378a14.37,14.37,0,0,1-.45-3.76,14.09,14.09,0,0,1,.06-3.78,14,14,0,0,1,.46,3.76A13.37,13.37,0,0,1,279.41,378Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.43,391.78a18.88,18.88,0,0,1-6,2,9.39,9.39,0,0,1,2.9-1.23A9.49,9.49,0,0,1,283.43,391.78Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,411.29a5.58,5.58,0,0,1,2-5.16c.11.1-.66,1.09-1.19,2.51S289.16,411.29,289,411.29Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.83,425.59a20.59,20.59,0,0,1-2.23-4,20.88,20.88,0,0,1-1.76-4.27,41.15,41.15,0,0,1,4,8.32Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.1,
    y: 190.43,
    width: 72.28,
    height: 75.57,
    transform: "translate(-18.61 31.12) rotate(-5.01)",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.28,
    y: 192.89,
    width: 59.87,
    height: 75.57,
    transform: "translate(-18.93 28.68) rotate(-5.01)",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.6 195.99 315.49 268.84 324.91 268.02 317.07 195.25 308.6 195.99",
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.78,237c0-.05.56,0,1.56-.17a12.85,12.85,0,0,0,4-1.27,12.13,12.13,0,0,0,4.63-4.09,11.35,11.35,0,0,0,1.78-7.26,11,11,0,0,0-3.09-6.79,11.38,11.38,0,0,0-5.41-2.94,11.19,11.19,0,0,0-4.2-.16c-1,.16-1.52.36-1.54.31s.12-.08.37-.17a7.27,7.27,0,0,1,1.13-.34,10.8,10.8,0,0,1,4.32,0,11,11,0,0,1,8.94,10,11.69,11.69,0,0,1-1.9,7.57,12.39,12.39,0,0,1-4.86,4.15,12,12,0,0,1-4.17,1.14,9.73,9.73,0,0,1-1.17,0C288.92,237,288.78,237,288.78,237Z",
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351,222.37a22.49,22.49,0,0,0-.43-2.57,10.59,10.59,0,0,0-3.87-5.73,10.43,10.43,0,0,0-9.85-1.45,9.69,9.69,0,0,0-2.62,1.42,9.53,9.53,0,0,0-2.19,2.2,10.34,10.34,0,0,0,0,12.25,9.38,9.38,0,0,0,2.19,2.21,9.69,9.69,0,0,0,2.62,1.42,10.4,10.4,0,0,0,9.85-1.46,10.54,10.54,0,0,0,3.87-5.72,22.89,22.89,0,0,0,.43-2.57,8,8,0,0,1-.23,2.62,10.69,10.69,0,0,1-8.39,8,10.81,10.81,0,0,1-5.7-.44,10.17,10.17,0,0,1-2.75-1.47,10,10,0,0,1-2.3-2.3,10.77,10.77,0,0,1,0-12.86,10,10,0,0,1,2.3-2.3,10.17,10.17,0,0,1,2.75-1.47,10.81,10.81,0,0,1,5.7-.44,10.69,10.69,0,0,1,8.39,8A8,8,0,0,1,351,222.37Z",
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.13,210.82a14.12,14.12,0,0,0-4.63,1.28,10.48,10.48,0,0,0,0,18.68,13.81,13.81,0,0,0,4.63,1.28s-.12,0-.34,0a9.25,9.25,0,0,1-1,0,9.83,9.83,0,0,1-3.47-1,10.53,10.53,0,0,1-4.1-3.44,11.15,11.15,0,0,1-1.44-2.84,11.46,11.46,0,0,1-.55-3.39,10.9,10.9,0,0,1,2-6.23,10.54,10.54,0,0,1,4.1-3.44,10.29,10.29,0,0,1,3.47-1,6.82,6.82,0,0,1,1,0C382,210.79,382.13,210.8,382.13,210.82Z",
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.17,251.53a22.49,22.49,0,0,0-.43-2.57,10.56,10.56,0,0,0-3.88-5.73,10.41,10.41,0,0,0-9.84-1.45,9.89,9.89,0,0,0-2.63,1.42,9.69,9.69,0,0,0-2.18,2.2,10.32,10.32,0,0,0,0,12.25,9.78,9.78,0,0,0,2.19,2.21,9.89,9.89,0,0,0,2.63,1.42,10.5,10.5,0,0,0,13.72-7.18,22.89,22.89,0,0,0,.43-2.57,8.38,8.38,0,0,1-.23,2.62,10.69,10.69,0,0,1-8.39,8,10.81,10.81,0,0,1-5.7-.44,10,10,0,0,1-2.75-1.47,10.28,10.28,0,0,1-2.31-2.3,10.81,10.81,0,0,1,0-12.86,10.95,10.95,0,0,1,5.06-3.77,10.81,10.81,0,0,1,5.7-.44,10.69,10.69,0,0,1,8.39,8A8.38,8.38,0,0,1,376.17,251.53Z",
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.39,267.35a13.93,13.93,0,0,0-1.84-4.43,10.55,10.55,0,0,0-10-4.52,10.61,10.61,0,0,0-5.68,2.59,10.5,10.5,0,0,0-2.88,4.26,14.14,14.14,0,0,0-.69,4.75s0-.11-.08-.33a7.67,7.67,0,0,1-.1-1,10.29,10.29,0,0,1,.52-3.57,10.6,10.6,0,0,1,2.91-4.49,10.85,10.85,0,0,1,2.64-1.79,11.84,11.84,0,0,1,3.29-1,11,11,0,0,1,6.43,1.2,10.62,10.62,0,0,1,3.92,3.64,10,10,0,0,1,1.39,3.32c.1.42.11.75.15,1S327.41,267.35,327.39,267.35Z",
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.28,190.4a20,20,0,0,0-.43-2.57A10.59,10.59,0,0,0,360,182.1a10.42,10.42,0,0,0-9.85-1.45,10.49,10.49,0,0,0-4.81,3.62,10.34,10.34,0,0,0,0,12.25,9.38,9.38,0,0,0,2.19,2.21,9.69,9.69,0,0,0,2.62,1.42,10.38,10.38,0,0,0,9.85-1.46,10.54,10.54,0,0,0,3.87-5.72,20.27,20.27,0,0,0,.43-2.57,8,8,0,0,1-.23,2.62,10.7,10.7,0,0,1-8.38,8,10.8,10.8,0,0,1-5.7-.44,10.82,10.82,0,0,1-5.06-3.77,10.81,10.81,0,0,1,0-12.86,10.24,10.24,0,0,1,2.3-2.3A10.08,10.08,0,0,1,350,180.2a10.77,10.77,0,0,1,10.23,1.61,10.58,10.58,0,0,1,3.85,6A8,8,0,0,1,364.28,190.4Z",
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.63,192.84a22.49,22.49,0,0,0-.43-2.57,10.67,10.67,0,0,0-3.88-5.73,10.42,10.42,0,0,0-9.85-1.45,9.69,9.69,0,0,0-2.62,1.42,9.94,9.94,0,0,0-2.19,2.2,10.34,10.34,0,0,0,0,12.25,10.42,10.42,0,0,0,4.81,3.63,10.54,10.54,0,0,0,5.46.47,10.37,10.37,0,0,0,4.39-1.93,10.62,10.62,0,0,0,3.88-5.72,22.89,22.89,0,0,0,.43-2.57,8.24,8.24,0,0,1-.24,2.62,10.61,10.61,0,0,1-3.84,6A10.79,10.79,0,0,1,304.31,203a10.08,10.08,0,0,1-2.76-1.47,10.45,10.45,0,0,1-2.3-2.3,10.81,10.81,0,0,1,0-12.86,10.24,10.24,0,0,1,2.3-2.3,10.08,10.08,0,0,1,2.76-1.47,10.8,10.8,0,0,1,5.7-.44,10.7,10.7,0,0,1,8.38,8A8.24,8.24,0,0,1,318.63,192.84Z",
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.53 191.43 367.71 264.26 377.87 263.37 370.39 190.57 360.53 191.43",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.67,171.4c0-.36,1-.75,2.8-1.16s4.45-.83,7.62-1.44c1.58-.31,3.29-.67,5.08-1.15.89-.25,1.81-.51,2.74-.82a25.89,25.89,0,0,0,2.68-1,2.67,2.67,0,0,0,1.32-1,.84.84,0,0,0,0-.36,5.47,5.47,0,0,0-.29-1.1A48.49,48.49,0,0,0,351,157a16.24,16.24,0,0,0-1.75-2.63c-.32-.37-.68-.76-1-1.06a5.88,5.88,0,0,0-1-.7,1.84,1.84,0,0,0-1.43-.28,5.26,5.26,0,0,0-1.91,1.21,37.7,37.7,0,0,0-7.08,8.2c-3.34,5.3-4.25,9.32-5,9.19-.34,0-.56-1.13-.41-3.06a24.91,24.91,0,0,1,2.2-7.87,33.58,33.58,0,0,1,7.07-10,9.82,9.82,0,0,1,3.66-2.41,6.45,6.45,0,0,1,2.78-.29,7.42,7.42,0,0,1,2.54.8,10.1,10.1,0,0,1,2,1.36,17.32,17.32,0,0,1,1.54,1.55,19.65,19.65,0,0,1,2.39,3.54,44.54,44.54,0,0,1,2.86,7.25,9.4,9.4,0,0,1,.46,2.34,5.59,5.59,0,0,1-.63,3,6,6,0,0,1-1.88,2.08,10.16,10.16,0,0,1-1.93,1,25.72,25.72,0,0,1-3.34,1c-1.06.27-2.09.47-3.09.64a52.17,52.17,0,0,1-13.5.4C332.72,172.05,331.68,171.76,331.67,171.4Z",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.94,171.84c0,.36-1.19.62-3.29.76a68.28,68.28,0,0,1-8.87-.07,64.62,64.62,0,0,1-13.19-2.22,15.89,15.89,0,0,1-4.06-1.66,6.83,6.83,0,0,1-2.19-2.05,5.46,5.46,0,0,1-.86-3.46,10.52,10.52,0,0,1,.62-2.62c.24-.65.48-1.31.73-2a31.5,31.5,0,0,1,1.86-4.12,18.24,18.24,0,0,1,2.84-3.91,16.55,16.55,0,0,1,1.82-1.63,11,11,0,0,1,2.24-1.33A8.38,8.38,0,0,1,316,147a11.42,11.42,0,0,1,4.19,2.19,39.9,39.9,0,0,1,9,10.22,26.67,26.67,0,0,1,3.44,8.48c.41,2.13.27,3.35-.06,3.42-.78.19-2-4.26-6.41-9.81a45.43,45.43,0,0,0-8.89-8.46,6.73,6.73,0,0,0-2.45-1.2,3.41,3.41,0,0,0-2.21.34,6,6,0,0,0-1.19.75,10.73,10.73,0,0,0-1.21,1.13,14,14,0,0,0-2,2.86,28.48,28.48,0,0,0-1.59,3.48l-.72,1.86a5.54,5.54,0,0,0-.38,1.27c0,.25,0,.2,0,.32a1.93,1.93,0,0,0,.62.58,11.72,11.72,0,0,0,2.83,1.27,92.14,92.14,0,0,0,12.22,3.15c3.58.7,6.53,1.22,8.56,1.7S333,171.48,332.94,171.84Z",
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.09,
    y: 167.73,
    width: 88,
    height: 25.01,
    transform: "translate(-14.42 30.83) rotate(-5.01)",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.29,
    y: 170.18,
    width: 79.55,
    height: 25.01,
    transform: "translate(-14.75 28.4) rotate(-5.01)",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.66 171.57 303.22 196.58 312.45 195.65 309.82 170.77 300.66 171.57",
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.34 165.94 369.21 190.69 379.38 189.8 376.84 164.89 366.34 165.94",
    style: {
      fill: "#DCE7F1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.1,170.77a13.91,13.91,0,0,0,1.79,4.46,10.45,10.45,0,0,0,3.79,3.46,10.47,10.47,0,0,0,14.77-5.54,14.25,14.25,0,0,0,.76-4.75s0,.12.07.34a8.06,8.06,0,0,1,.09,1,10,10,0,0,1-.57,3.56,10.55,10.55,0,0,1-3,4.46,11.21,11.21,0,0,1-2.67,1.75,11.84,11.84,0,0,1-3.3.92,10.9,10.9,0,0,1-6.42-1.28,10.62,10.62,0,0,1-3.87-3.69,10,10,0,0,1-1.34-3.34,7.67,7.67,0,0,1-.14-1C318.08,170.89,318.08,170.78,318.1,170.77Z",
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.65,193.93a14.1,14.1,0,0,0-1.78-4.45,10.5,10.5,0,0,0-3.8-3.47,10.43,10.43,0,0,0-11.83,1.33,10.45,10.45,0,0,0-2.94,4.22,13.7,13.7,0,0,0-.75,4.74s-.05-.11-.08-.33a6.7,6.7,0,0,1-.08-1,10.21,10.21,0,0,1,.56-3.56,10.61,10.61,0,0,1,3-4.45,11,11,0,0,1,2.66-1.75,11.35,11.35,0,0,1,3.31-.92,10.81,10.81,0,0,1,6.41,1.28,10.66,10.66,0,0,1,3.88,3.69,10.27,10.27,0,0,1,1.34,3.34,7.28,7.28,0,0,1,.13,1C327.67,193.81,327.67,193.93,327.65,193.93Z",
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.49,179a23,23,0,0,0-.43-2.56,10.64,10.64,0,0,0-3.88-5.73,10.37,10.37,0,0,0-4.39-1.93,10.54,10.54,0,0,0-5.46.48,9.65,9.65,0,0,0-2.62,1.41,10,10,0,0,0-2.19,2.21,10.34,10.34,0,0,0,0,12.25,9.94,9.94,0,0,0,2.19,2.2,9.42,9.42,0,0,0,2.62,1.42,10.43,10.43,0,0,0,5.46.47,10.24,10.24,0,0,0,4.39-1.92,10.64,10.64,0,0,0,3.88-5.73,22.49,22.49,0,0,0,.43-2.57,8.24,8.24,0,0,1-.24,2.62,10.54,10.54,0,0,1-3.84,6,10.72,10.72,0,0,1-10.24,1.61,10.08,10.08,0,0,1-2.76-1.47,10.24,10.24,0,0,1-2.3-2.3,10.8,10.8,0,0,1,0-12.85,10.29,10.29,0,0,1,2.3-2.31,10.65,10.65,0,0,1,2.76-1.47,10.9,10.9,0,0,1,5.7-.44,10.68,10.68,0,0,1,4.53,2.06,10.52,10.52,0,0,1,3.85,6A8.18,8.18,0,0,1,370.49,179Z",
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.58,184a22.49,22.49,0,0,0-.43-2.57,10.52,10.52,0,0,0-8.27-7.65,10.4,10.4,0,0,0-5.45.47,9.69,9.69,0,0,0-2.62,1.42,9.53,9.53,0,0,0-2.19,2.2,10.34,10.34,0,0,0,0,12.25,9.57,9.57,0,0,0,2.19,2.21,10,10,0,0,0,2.62,1.42,10.64,10.64,0,0,0,5.46.47,10.57,10.57,0,0,0,8.26-7.65,23.32,23.32,0,0,0,.43-2.57,7.94,7.94,0,0,1-.23,2.61,10.52,10.52,0,0,1-3.85,6,10.67,10.67,0,0,1-4.54,2.06,10.87,10.87,0,0,1-5.69-.44,10.36,10.36,0,0,1-2.76-1.47,10.09,10.09,0,0,1-2.3-2.31,10.76,10.76,0,0,1,0-12.85,10.82,10.82,0,0,1,5.06-3.77,10.87,10.87,0,0,1,5.69-.45,10.67,10.67,0,0,1,4.54,2.06,10.52,10.52,0,0,1,3.85,6A8,8,0,0,1,301.58,184Z",
    style: {
      fill: "#F6F9FC"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "379.16 189.8 344.94 192.8 285.3 198.03 345.67 201.12 351.33 265.7 385.54 262.7 379.16 189.8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 356.63,
    y: 165.3,
    width: 32.36,
    height: 25.01,
    transform: "translate(-14.11 33.25) rotate(-5.01)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M321.49,236a11.31,11.31,0,0,1-1.75,2.63,7.59,7.59,0,0,1-1.91,1.66l-1,.57a8.82,8.82,0,0,1-4.71,1.11c-7.23-.31-29.06-1.34-33.24-2.35-5-1.22-26.86-31-26.86-31l-14,9.85s15.49,27.29,28.32,36.42c8.15,5.8,50.79-.68,50.82-.69a92.43,92.43,0,0,0,9.9,1.22c4.67.12,4.68-.29,4.61-.84-.21-1.47-8.2-.53-6.6-1.72s9.9,0,9.62-1.54c-.37-2-8.71-.85-9.43-.8s-.8-1-.15-1c.93,0,10.68-.33,10.33-2.28-.19-1.09-2.1-.56-2.1-.56s-9.1,1-9.23,0,5.19-1.69,7-1.82,2.46-1,1.75-1.77c-.49-.51-6.05-.26-7.84-.09s-6.69.71-4.49-1.52,3-4.78,2.79-5.63A1,1,0,0,0,321.49,236Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.7,188.57s-11.74,12.32-4.27,30.2l9.88,16.16,20.05-15.18Z",
    style: {
      fill: "#3B5A76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.82,190.91c-.59-1.15-1.7-1.86-2.7-1.14h0a2,2,0,0,0-.09,1.92l5.09,10.75h0L381.69,195c-.58-1.15-1.78-1.72-2.44-.95a2,2,0,0,0,0,1.86l4.35,8.91-3.28-5.49c-.7-1.26-1.35-1.52-2-1.14s-.51,1.39-.27,1.89l3.06,6.6c-.24,1.38-1.16,5.78.64,7.91.1.11-.07.53,0,.66l-.58.9,1.39,8.29c3.59-2.06,6.62-16.09,6.81-19.48a10.53,10.53,0,0,0-1.06-5.58Z",
    style: {
      fill: "#ffbe9d"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "speech-bubble",
    "data-motion": "float",
    "data-delay": 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M464.37,145.79l-15.68-3.85.12,0A26,26,0,0,1,435.27,146a28.29,28.29,0,0,1-8.38-1.22A26.33,26.33,0,0,1,408.82,123,26,26,0,0,1,415.56,102a27.44,27.44,0,0,1,4.54-4c.85-.52,1.69-1.07,2.56-1.53l1.33-.64.67-.32.69-.25a26.15,26.15,0,0,1,34.28,15.85,27.06,27.06,0,0,1,1.45,8.46,26.06,26.06,0,0,1-3.76,13.59v-.15l7.05,12.72-7.29-12.58,0-.07,0-.07a25.83,25.83,0,0,0,3.62-13.43,26.51,26.51,0,0,0-1.47-8.33,25.6,25.6,0,0,0-4.58-8.08,25.83,25.83,0,0,0-29.11-7.43l-.68.25-.65.31L422.9,97c-.85.45-1.67,1-2.5,1.5a26.28,26.28,0,0,0-10.11,13.6,25.88,25.88,0,0,0,8.71,28,25.61,25.61,0,0,0,8,4.29,27.73,27.73,0,0,0,8.25,1.24,25.79,25.79,0,0,0,13.38-3.92l.06,0h.06Z",
    style: {
      fill: "#17324A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.7,108.13l.83,13.1a2.12,2.12,0,0,0,2,2h0a2.11,2.11,0,0,0,2.23-1.89l1.46-13.16a1.67,1.67,0,0,0-1.68-1.85l-3.2,0A1.67,1.67,0,0,0,432.7,108.13Z",
    style: {
      fill: "#0A6EBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439,130.58a3.2,3.2,0,1,1-2-4A3.21,3.21,0,0,1,439,130.58Z",
    style: {
      fill: "#0A6EBD"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewards);
export default __webpack_public_path__ + "static/media/rewards.5fc6fd5575e91943366c81f617a65720.svg";
export { ForwardRef as ReactComponent };